import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import Search from '../../common/Search';
import LandingPageCard from '../../common/LandingPageCard';
import RiskProfileCard from '../../common/RiskProfileCard';
import BannerCarousel from './banner/BannerCarousel';
import { useRouter } from 'next/router';
import { routes } from '../../../config/routes';
import { Row, Col, P1, P2 } from 'pfm-ui-components';
import * as SearchConstants from '../../../constants/Search';
import { getIconForFundCard } from './util';
import { FundTypes } from '../../../constants/MutualFundPage';
import { pxToRem } from '../../../styles/utils';
import { BannerDetails, SearchResult } from '../../../pages/mutualFunds';
import { useAppContext } from '../../../store';
import { featureToggle, INITIATE_ACTION } from '../../../constants/common';
import { KycDetails } from '../../../pages/kyc';
import API from '../../../API';
import FullPageLoader from '../../common/FullPageLoader';
import KycModals from '../kyc/KycModals';
import { KYC_MODALS } from '../../../constants/Kyc';
import { getTransactionRoute, isReadyToInvest, TransactionRoute } from '../../../utils/transaction';
import { EXPLORE_SCHEMES_USER_FLOW } from '../../../constants/ExplorePage';
import LeftArrowBurgundy from '../../../assets/icons/left-arrow-burgundy.svg';
import { CHARACTER_INPUT_AND_EMPTY_SPACE_ONLY, No, Yes } from './../../../constants/common';
import { convertToCamelCase } from '../../../../src/utils/common';
import Joyride, { STATUS, LIFECYCLE } from 'react-joyride';
import { theme } from 'pfm-ui-components';
import DEVICE_TYPE from '../../../constants/device';
import { useDeviceTypeUserGuide } from '../../../utils/deviceType';
import { ARROW_UP, ARROW_DOWN, ARROW_LEFT } from '../../../constants/UserGuideSvg';
import Link from 'next/link';
import { getIconForNavigationTab } from '../../common/NavigationFooterTab/util';
import { useDeviceType } from '../../../utils/deviceType';
import GTM from '../../../GTM';
interface MutualFundProps {
  searchKey: string;
  setSearchKey: Function;
  searchResult: Array<SearchResult>;
  isLoggedIn: boolean;
  navigateToLogin: Function;
  onRiskProfileClick: Function;
  onBannerClick: Function;
  bannerDetails: Array<BannerDetails>;
  navigationToV2: Function;
  showPFMV2NavigationButton: boolean;
  showMFUserGuide: Number;
  hasPortfolio: boolean;
}

export default function MutualFund(props: MutualFundProps) {
  const {
    searchKey,
    setSearchKey,
    searchResult,
    isLoggedIn,
    navigateToLogin,
    onRiskProfileClick,
    bannerDetails,
    onBannerClick,
    navigationToV2,
    showPFMV2NavigationButton,
    showMFUserGuide,
    hasPortfolio,
  } = props;
  const router = useRouter();
  const [searchOptions, setSearchOptions] = useState(undefined);
  const { state, setState } = useAppContext();
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;

  const [showUserGuide, setUserGuide] = useState(false);
  const defaultTooltipStyles = {
    options: {
      primaryColor: theme.palette.burgundy1,
      zIndex: 90,
      textColor: theme.palette.grey2,
      overlayColor: 'rgba(0, 0, 0, 0.80)',
      backgroundColor: 'transparent',
      width: '200px',
    },
    buttonClose: {
      display: 'none',
    },
    tooltip: {
      margin: '18px',
    },
    tooltipContainer: {
      textAlign: 'left',
    },
    tooltipContent: {
      padding: '0px',
      color: '#fff',
      fontSize: '14px',
    },
    spotlight: {
      borderRadius: '50%',
    },
    tooltipFooter: {
      marginTop: 10,
      justifyContent: 'flex-start',
    },
    tooltipFooterSpacer: {
      flex: '0 1 40%',
    },
    buttonSkip: {
      borderRadius: 6,
      border: '1px solid '.concat(theme.palette.burgundy1),
      color: theme.palette.burgundy1,
      padding: '6px 16px',
      backgroundColor: '#fff',
      fontSize: '14px',
      outline: 'none',
    },
    buttonNext: {
      border: '1px solid #fff',
      borderRadius: 6,
      padding: '6px 16px',
      fontSize: '14px',
      outline: 'none',
    },
  };
  const [tooltipStyle, setTooltipStyle] = useState(defaultTooltipStyles);
  // const [scrollDisable, setScrollDisable] = useState(false);
  // const [spotlightPadding, setSpotlightPadding] = useState(6);
  const defaultMFUserGuideSteps = [
    {
      target: '#mf_search_bar > form > div > div > div > div > svg',
      content: 'Find scheme of your choice',
      disableBeacon: true,
      placement: 'right',
    },
    {
      target: '#mf_cards_All_Mutual_Funds',
      content: 'Invest in top schemes across categories & sub-categories',
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      target: '#mf_cards_Save_Tax',
      content: 'Invest in ELSS to save tax',
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      target: '#mf_cards_Plan_Goals_With_SIP',
      content: 'Start a SIP in top funds',
      disableBeacon: true,
      placement: 'top',
    },
    {
      target: '#mf_cards_Investment_Ideas',
      content: 'Invest basis your goals and needs',
      disableBeacon: true,
      placement: 'top',
    },
  ];

  const [userGuideMFsteps, setUserGuideMFsteps] = useState(defaultMFUserGuideSteps);
  const [userGuideSeen, setUserGuideSeen] = useState(false);
  const device = useDeviceTypeUserGuide();

  useEffect(() => {
    if (state.customerId) {
      const page = 'mf';
      API.customer
        .getUserGuideDetails(page as string)
        .then((res: any) => {
          if (res && res?.data?.data?.toShow) {
            setUserGuide(true);
            setUserGuideSeen(false);
          } else {
            setUserGuideSeen(true);
          }
        })
        .catch((error) => {
          setUserGuideSeen(false);
        });
    }
  }, [state.customerId]);

  useEffect(() => {
    if (showMFUserGuide) setUserGuide(true);
  }, [showMFUserGuide]);

  useEffect(() => {
    if (!hasPortfolio) {
      setUserGuideMFsteps([
        ...defaultMFUserGuideSteps,
        {
          target: '#mf_risk_profile_card',
          content: 'Invest in funds that match your risk profile',
          disableBeacon: true,
          placement: 'top',
          locale: { last: 'Ok, Got it. Thanks!' },
        },
      ]);
    } else if (device === DEVICE_TYPE.DESKTOP) {
      setUserGuideMFsteps([
        ...defaultMFUserGuideSteps,
        {
          target: '#mf_risk_profile_card',
          content: 'Invest in funds that match your risk profile',
          disableBeacon: true,
          placement: 'top',
        },
        {
          target: '#mf_user_guide_portfolio_nav_header',
          content: 'View your holdings, invest more and get statements',
          disableBeacon: true,
          placement: 'bottom',
          locale: { last: 'Ok, Got it. Thanks!' },
        },
      ]);
    } else {
      setUserGuideMFsteps([
        ...defaultMFUserGuideSteps,
        {
          target: '#mf_risk_profile_card',
          content: 'Invest in funds that match your risk profile',
          disableBeacon: true,
          placement: 'top',
        },
        {
          target: '#mf_user_guide_portfolio_nav_footer',
          content: 'View your holdings, invest more and get statements',
          disableBeacon: true,
          placement: 'top',
          locale: { last: 'Ok, Got it. Thanks!' },
        },
      ]);
    }
  }, [device, hasPortfolio]);

  useEffect(() => {
    if (searchResult) {
      setSearchOptions(searchResult.map((s) => convertToCamelCase(s.vcSchemeName)));
    } else if (searchKey && searchKey.length < 3) {
      setSearchOptions(undefined);
    }
  }, [searchResult]);

  const onSearchInputChange = (value: string) => {
    if (CHARACTER_INPUT_AND_EMPTY_SPACE_ONLY.test(value)) {
      setSearchKey(value);
    }
  };
  const onEnter = (e: any) => {
    // setSearchInputValue('');
  };

  const onDropDownOptionSelect = (value: any) => {
    if (searchResult[value].vcContentSecurityCode) {
      // Check if it's a NFO scheme or not
      if (searchResult[value].isnfo === 'Y') {
        const nfoRoute = `${routes.NFO.url}?fundCode=${searchResult[value].vcContentSecurityCode}`;
        const fallBackRoute = `&fallBackTo=${routes.MUTUAL_FUND.url}`;
        router.push(`${nfoRoute}${fallBackRoute}`, nfoRoute, {
          shallow: true,
        });
      } else {
        const schemeDetailRoute = `${routes.SCHEME_DETAIL.url}/${searchResult[value].vcContentSecurityCode}`;
        const fallBackRoute = `?fallBackTo=${routes.MUTUAL_FUND.url}`;
        router.push(`${schemeDetailRoute}${fallBackRoute}`, schemeDetailRoute, {
          shallow: true,
        });
      }
    }
  };

  const onCardClickHandler = (value: any) => {};

  const handleJoyrideCallback = (data) => {
    const { status, index, lifecycle } = data;

    if (document.querySelector('#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span')) {
      if (index == 0) {
        document.querySelector(
          '#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span'
        ).innerHTML = '';
        document.querySelector(
          '#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span'
        ).innerHTML = ARROW_LEFT;
      } else if (index == 1 || index == 2 || (index == 6 && device === DEVICE_TYPE.DESKTOP)) {
        document.querySelector(
          '#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span'
        ).innerHTML = '';
        document.querySelector(
          '#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span'
        ).innerHTML = ARROW_UP;
      } else {
        document.querySelector(
          '#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span'
        ).innerHTML = '';
        document.querySelector(
          '#react-joyride-step-' + index + ' > div > div > div.__floater__arrow > span'
        ).innerHTML = ARROW_DOWN;
      }
    }

    if (index == 0) {
      setTooltipStyle({ ...defaultTooltipStyles });
    }

    if (index == 5) {
      if (hasPortfolio) {
        let spotlight = {
          borderRadius: '4px',
        };
        setTooltipStyle({ ...tooltipStyle, spotlight });
        // setScrollDisable(false);
      } else {
        let tooltipFooter = {
          marginTop: 10,
          justifyContent: 'flex-start',
          display: 'block',
        };

        let spotlight = {
          borderRadius: '4px',
        };

        setTooltipStyle({ ...tooltipStyle, tooltipFooter, spotlight });
        // setSpotlightPadding(6);
        // setScrollDisable(false);
      }
    }

    if (index == 6) {
      let tooltipFooter = {
        marginTop: 10,
        justifyContent: 'flex-start',
        display: 'block',
      };

      let spotlight = {
        borderRadius: '4px',
      };

      let options = {
        primaryColor: theme.palette.burgundy1,
        zIndex: 98,
        textColor: theme.palette.grey2,
        overlayColor: 'rgba(0, 0, 0, 0.80)',
        backgroundColor: 'transparent',
        width: '200px',
      };
      setTooltipStyle({ ...tooltipStyle, options, tooltipFooter, spotlight });
      // setSpotlightPadding(6);
      // setScrollDisable(true);
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status) && lifecycle === LIFECYCLE.COMPLETE) {
      // Need to set our running state to false, so we can restart if we click start again.
      setUserGuide(false);
      window.scrollTo(0, 0);
      const page = 'mf';
      userGuideSeen ||
        API.customer
          .updateUserGuideDetails(page as string)
          .then((res: any) => {})
          .catch((error) => {});
    }
  };

  return (
    <LandingPageContainer>
      <Joyride
        callback={handleJoyrideCallback}
        styles={tooltipStyle}
        steps={userGuideMFsteps}
        /*floaterProps={{styles: {arrow: {display: 'none'}}}}*/ run={showUserGuide}
        spotlightPadding={6}
        continuous={true}
        hideBackButton={true}
        showSkipButton={true}
        disableOverlayClose={true}
        disableScrolling={false}
        scrollOffset={200}
      />
      {/* {showPFMV2NavigationButton && (
        <OldMutualFundContainer>
          <StyledLeftArrowBurgundy /> <PFMV2LinkText onClick={navigationToV2}>Old MF Module</PFMV2LinkText>
        </OldMutualFundContainer>
      )} */}
      <SearchBarContainer>
        <StyledCol id="mf_search_bar" md={10}>
          <StyledSearchBar>
            <form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <Search
                name={SearchConstants.NAME}
                value={searchKey}
                placeholder={SearchConstants.PLACEHOLDER}
                // filter={true}
                onChange={onSearchInputChange}
                onEnter={onEnter}
                SearchResult={searchOptions}
                onSelect={onDropDownOptionSelect}
                onNoResultFound={SearchConstants.PLEASE_ENTER_CORRECT_SCHEME_NAME}
              />
            </form>
          </StyledSearchBar>
          {isMobile ? (
            <Link href={`${routes.CART.url}`}>
              <CartIconWrapper>
                <CartContainer enableCart={isLoggedIn}>
                  {getIconForNavigationTab('CartSvg')}
                  {state.cartSchemeCount ? <CartCounter>{state.cartSchemeCount}</CartCounter> : ''}
                </CartContainer>
              </CartIconWrapper>
            </Link>
          ) : null}
        </StyledCol>
      </SearchBarContainer>
      <Divider />
      <FundCardContainer>
        {FundTypes.map((fundCardDetails, index) => (
          <StyledCol xs={6} md={6} lg={3} key={`Mutual-Funds-${index}`}>
            <CardWrapper
              onClick={() => {
                setState({ ...state, schemeListingState: null });
                if (isLoggedIn) {
                  // If Save Tax Card is clicked then pass userflow of save tax and do not expose that in browser
                  // For other cards click, just navigate to individual page only
                  if (fundCardDetails.key === 'Save_Tax') {
                    GTM.mflp.mutualFundTileClick('Save_Tax')
                    router.push(
                      fundCardDetails.route + `&userFlow=${EXPLORE_SCHEMES_USER_FLOW.SAVE_TAX}`,
                      fundCardDetails.route,
                      { shallow: true }
                    );
                  } else if (fundCardDetails.key === 'Plan_Goals_With_SIP') {
                    // GTM.mflp.mutualFundTileClick(fundCardDetails.title);
                    router.push(
                      routes.EXPLORE.url + '/Equity?isSip=true&route=instasip',
                      routes.EXPLORE.url + '/Equity',
                      { shallow: true }
                    );
                  } else {
                    // GTM.mflp.mutualFundTileClick(fundCardDetails.title);
                    router.push(fundCardDetails.route, undefined, { shallow: true });
                  }
                } else {
                  navigateToLogin(state.channelId);
                }
              }}
            >
              <LandingPageCard
                heading={fundCardDetails.title}
                displayIcon={getIconForFundCard(fundCardDetails.icon)}
                onCardClickHandler={onCardClickHandler}
                className="mutual-fund-card-style"
              />
            </CardWrapper>
          </StyledCol>
        ))}
      </FundCardContainer>
      <RiskProfileCardWrapper>
        <StyledCol md={12}>
          <RiskProfileCard
            onClick={() => {
              GTM.mflp.mutualFundTileClick('Not sure where to invest - explore');
              if (featureToggle.INVEST_BASIS_RISK_PROFILE) {
                if (isLoggedIn) {
                  onRiskProfileClick();
                } else {
                  // navigateToLogin(
                  //   routes.MUTUAL_FUND.url + `?initiateAction=${INITIATE_ACTION.INVEST_BASIS_RISK_PROFILE}`
                  // );
                  navigateToLogin(state.channelId);
                }
              }
            }}
          />
        </StyledCol>
      </RiskProfileCardWrapper>
      {bannerDetails && (
        <>
          <Divider />
          <BannerCarouselWrapper>
            <BannerContainer>
              <BannerCarousel
                imageDetails={bannerDetails}
                enableAutoPlay={true}
                infiniteScroll={true}
                onBannerClick={onBannerClick}
                shouldShowDots={true}
                desktopSlidesToShow={2}
              />
            </BannerContainer>
          </BannerCarouselWrapper>
        </>
      )}
    </LandingPageContainer>
  );
}

const LandingPageContainer = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledCol = styled(Col)`
  padding: 0;
  flex-direction: row;
  // justify-content: space-between;
  ${up('md')} {
    flex-direction: column;
  }
`;
const SearchBarContainer = styled(Row)`
  margin: ${pxToRem(12)} ${pxToRem(12)} 0 ${pxToRem(16)};
  padding: ${pxToRem(12)} 0 ${pxToRem(4)} 0;
  ${up('md')} {
    display: flex;
    justify-content: center;
    margin-bottom: ${pxToRem(28)};
    padding: 0 ${pxToRem(10)};
    margin-top: ${pxToRem(40)};
  }
`;

const Divider = styled.article`
  border-bottom: ${pxToRem(2)} solid ${(props) => props.theme.palette.grey4};
  margin: ${pxToRem(10)} ${pxToRem(8)} 0 ${pxToRem(16)};
  opacity: 0.6;
  ${up('md')} {
    margin: ${pxToRem(10)} ${pxToRem(16)} 0 ${pxToRem(16)};
  }
`;

const FundCardContainer = styled(Row)`
  margin: ${pxToRem(3)} ${pxToRem(8)} ${pxToRem(14)} ${pxToRem(10)};
  ${up('md')} {
    padding: 0 ${pxToRem(10)};
    margin: 0;
  }
`;

const CardWrapper = styled.div`
  width: 100%;
  margin-top: ${pxToRem(12)};
  padding: 0 ${pxToRem(6)};
  display: flex;
  flex: 1;
  ${up('md')} {
    width: 98%;
    margin: ${pxToRem(12)} 0;
    padding: ${pxToRem(15)} ${pxToRem(6)};
  }
`;

const StyledLandingPageCard = styled(LandingPageCard)`
  flex: 1;
`;
const RiskProfileCardWrapper = styled(Row)`
  margin: 0 ${pxToRem(12)} ${pxToRem(4)} ${pxToRem(16)};
  :hover {
    cursor: pointer;
  }
  ${up('md')} {
    margin: ${pxToRem(8)} ${pxToRem(16)} ${pxToRem(16)} ${pxToRem(16)};
  }
`;

const BannerContainer = styled(Col)`
  margin: ${pxToRem(10)} 0;
  padding-right: 0;
  padding-left: 0;
  ${up('md')} {
    margin: ${pxToRem(16)} 0;
  }
`;

const BannerCarouselWrapper = styled(Row)`
  width: 103%;
  /* margin: ${pxToRem(4)} 0; */
  margin-bottom: ${pxToRem(100)};
  ${up('md')} {
    width: 100.5%;
    margin: ${pxToRem(8)} 0;
    margin-bottom: ${pxToRem(32)};
  }
`;

// const OldMutualFundContainer = styled.div`
//   margin-left: ${pxToRem(16)};
//   margin-top: ${pxToRem(16)};
//   display: flex;
// `;

// const PFMV2LinkText = styled(P1)`
//   margin-left: ${pxToRem(8)};
//   color: ${(props) => props.theme.palette.burgundy1};
//   cursor: pointer;
//   text-decoration: underline;
// `;

// const StyledLeftArrowBurgundy = styled(LeftArrowBurgundy)`
//   height: ${pxToRem(16)};
//   width: ${pxToRem(16)};
//   align-self: center;
// `;

const CartIconWrapper = styled.article`
  cursor: pointer;
  align-self: center;
  padding-left: ${pxToRem(8)};
  position: relative;
`;

const CartContainer = styled.article<{ enableCart: boolean }>`
  position: relative;
  display: ${(props) => (props.enableCart ? 'flex' : 'none')};
  padding: 0 -${pxToRem(4)} 0 0;
`;
const CartCounter = styled(P2)`
  position: absolute;
  left: ${pxToRem(24)};
  bottom: ${pxToRem(24)};
  border-radius: ${pxToRem(50)};
  width: ${pxToRem(16)};
  height: ${pxToRem(14)};
  color: ${(props) => props.theme.palette.white};
  line-height: ${pxToRem(12)};
  font-size: ${pxToRem(10)};
  text-align: center;
  background-color: #4a4a4a;
  display: ${(props) => (props.disableNotificationCount ? 'none' : 'inline')};
`;

const StyledSearchBar = styled.div`
  width: 100%;
`;
